export default {"src":"/_next/static/media/bnb-native-coin.8d3cd5ce.svg","height":2496,"width":2496,"blurWidth":0,"blurHeight":0};